import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { LoaderCircle } from "lucide-react";
import { Slot } from "radix-ui";
import { cn } from "../lib/cn.js";
export const buttonVariants = cva("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-55 [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
        variant: {
            primary: "bg-primary text-primary-foreground hover:bg-primary/90",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            outline: "border border-input bg-card text-foreground hover:bg-muted",
            ghost: "text-foreground hover:bg-muted",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            link: "text-primary underline-offset-4 hover:underline",
        },
        size: { sm: "h-8 px-3", md: "h-10 px-4", lg: "h-11 px-6 text-base", icon: "size-10" },
    },
    defaultVariants: { variant: "primary", size: "md" },
});
export function Button({ className, variant, size, asChild, loading, disabled, children, type, ...props }) {
    const Component = asChild ? Slot.Root : "button";
    return (_jsx(Component, { className: cn(buttonVariants({ variant, size }), className), disabled: disabled || loading, "aria-busy": loading || undefined, ...(asChild ? {} : { type: type ?? "button" }), ...props, children: asChild ? (children) : (_jsxs(_Fragment, { children: [loading ? _jsx(LoaderCircle, { className: "animate-spin", "aria-hidden": "true" }) : null, children] })) }));
}
//# sourceMappingURL=button.js.map